import React from 'react';
import TheMassAddPage from '../components/TheMassAddPage';
import PageHeader from '../components/PageHeader';
import Container from '../components/Container';
import config from '../config';
import { NextSeo } from 'next-seo';

const MassAdd = () => {
  const description = `Opt-in to any number of Algorand ASAs at once.`;

  return (
    <>
      <NextSeo title={`Mass Add - ${config.siteName}`} description={description} />

      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader heading={'Mass Add'} description={description} docsLink='https://docs.shittykitties.art/website-utilities/mass-add' />
        <Container>
          <TheMassAddPage />
        </Container>
      </div>
    </>
  );
};

export default MassAdd;
